import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { TablePagination } from 'modules/_shared/Table/components/TablePagination';

import { useAvailableRangesView } from './context/AvailableRangesViewContext';
import AvailableRangeViewCollapsedTable from './components/AvailableRangeViewCollapsedTable';
import AvailableRangesViewExpandedTable from './components/AvailableRangesViewExpandedTable';

const AvailableRangesView: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useAvailableRangesView();

  const hasData = data.totalAvailableRanges > 0;

  return (
    <div key="available-ranges-card">
      <AvailableRangeViewCollapsedTable />

      {data.expandView && <AvailableRangesViewExpandedTable />}

      {hasData && data.expandView && (
        <>
          <TablePagination
            totalRows={data.totalAvailableRanges || 0}
            onChangePage={actions.handleChangePage}
            onChangeRowsPerPage={actions.handleChangeRowsPerPage}
          />

          <span className="sub-text mt-2">
            <i>{t('AvailableSharesInfo')}</i>
          </span>
        </>
      )}
    </div>
  );
};

export default AvailableRangesView;
